import React from "react";
import { Column, Container, Icon, Row } from "../components";
import { Spacer } from "./spacer";
import { Text } from "./text";
import { useParams } from "react-router-dom";
import {
  useOrderQuery,
  OrderableType,
  OrderItemMultiPass,
  useSpaceV2Query,
  useLocationV2Query,
} from "./api";
import { useGetPartnerOffering } from "../data/api";
import { getMainOrderItem } from "./order";
import { TemplateOfferingConfirmOrderBase } from "./template_offering_confirm_order_base";
import { Divider } from "./divider";
import { Location } from "../data";
import { PartnerConfig } from "./partner_config";
import { getPartnerOfferingName } from "@/offering/get_partner_offering_name";

interface TemplateOfferingConfirmOrderMultiPassParams {
  orderID: string;
  offeringID: string;
}

interface TemplateOfferingConfirmOrderMultiPassProps {
  showTalkWithUsPrompt?: boolean;
  partnerConfig: PartnerConfig;
}

export function TemplateOfferingConfirmOrderMultiPass(
  props: TemplateOfferingConfirmOrderMultiPassProps
) {
  const { partnerConfig, showTalkWithUsPrompt } = props;
  const pageParams = useParams<TemplateOfferingConfirmOrderMultiPassParams>();
  const order = useOrderQuery(pageParams.orderID);
  const orderItem = getMainOrderItem(order);
  if (!orderItem || orderItem.type !== OrderableType.AddOn) {
    throw new Error("Invalid order");
  }
  const partnerOfferingID = pageParams.offeringID;
  const partnerOffering = useGetPartnerOffering(partnerOfferingID);
  const space = useSpaceV2Query(orderItem.details.spaceID);
  const location = useLocationV2Query(space.locationID);

  return (
    <TemplateOfferingConfirmOrderBase
      showTalkWithUsPrompt={showTalkWithUsPrompt}
      partnerOfferingID={partnerOfferingID}
      partnerOffering={partnerOffering}
      offeringName={getPartnerOfferingName(partnerOffering)}
      partnerConfig={partnerConfig}
      order={order}
      location={location}
      space={space}
      mobileCheckoutBox={
        <MultiPassMobileCheckoutBoxOrderPreview
          location={location}
          orderItem={orderItem}
        />
      }
      desktopCheckoutBox={
        <MultiPassDesktopCheckoutBoxOrderPreview
          location={location}
          orderItem={orderItem}
        />
      }
    />
  );
}

interface MultiPassMobileCheckoutBoxOrderPreviewProps {
  location: Location;
  includeQuantity?: boolean;
  orderItem: OrderItemMultiPass;
}

export function MultiPassMobileCheckoutBoxOrderPreview(
  props: MultiPassMobileCheckoutBoxOrderPreviewProps
) {
  const { location, orderItem } = props;

  return (
    <Container>
      <Container paddingVertical={16}>
        <Row alignItems="center">
          <Icon name="map-pin" />
          <Spacer size={8} direction="horizontal" />
          <Column flex={1}>
            <Text>{location.city}</Text>
            <Text size="sm">{location.streetAddress}</Text>
          </Column>
        </Row>
      </Container>
      <Divider />
      <Container paddingVertical={16}>
        <Row>
          <Row expanded alignItems="center" flex={1}>
            <Icon name="box" />
            <Spacer size={8} direction="horizontal" />
            <Text>{orderItem.details.name}</Text>
          </Row>
        </Row>
      </Container>
      <Divider />
    </Container>
  );
}

interface MultiPassDesktopCheckoutBoxOrderPreviewProps {
  location: Location;
  includeQuantity?: boolean;
  orderItem: OrderItemMultiPass;
}

export function MultiPassDesktopCheckoutBoxOrderPreview(
  props: MultiPassDesktopCheckoutBoxOrderPreviewProps
) {
  const { location, orderItem } = props;

  return (
    <Container>
      <Container paddingHorizontal={16} height={64}>
        <Row expanded alignItems="center" flex={1}>
          <Icon name="map-pin" />
          <Spacer size={8} direction="horizontal" />
          <Column flex={1}>
            <Text>{location.city}</Text>
            <Text size="sm">{location.streetAddress}</Text>
          </Column>
        </Row>
      </Container>
      <Divider />
      <Container paddingHorizontal={16} height={64}>
        <Row expanded alignItems="center" flex={1}>
          <Icon name="box" />
          <Spacer size={8} direction="horizontal" />
          <Text>{orderItem.details.name}</Text>
        </Row>
      </Container>
    </Container>
  );
}
